import { MouseEvent } from 'react'
import { MutableRefObject } from 'react'
import { GridApiPro } from '@microservices/wiskey-react-table-component'

import { ConfigActionsType } from '@pages/ConfiguredEntity/hooks/useGetActions'

import { useTooltip } from '@hooks'
import { BIND_TYPE } from '@constants'
import { ConfiguredColumn } from '@types'

type UseHandleTooltip = {
  configActions: ConfigActionsType
  columns: ConfiguredColumn[]
  apiRef: MutableRefObject<GridApiPro>
}

export const useHandleTooltip = (props: UseHandleTooltip) => {
  const { columns, apiRef, configActions } = props

  const {
    tooltipPosition,
    tooltipData,
    handleCloseTooltip,
    handleOpenTooltip: onOpenTooltip,
  } = useTooltip()

  const handleOpenTooltip = (event: MouseEvent<HTMLElement>, isHeader?: boolean) => {
    const columnHeaderName = (event.target as HTMLElement)?.innerText
    const column = columns.find(column => column.title === columnHeaderName)

    if (isHeader) {
      const columnId = column?.id

      if (!columnId || !configActions.actionsData.on_header_tooltip[columnId]) {
        return
      }

      onOpenTooltip(event, {
        action: configActions.actionsData.on_header_tooltip[columnId],
        column,
      })

      return
    }

    const field = (event.target as HTMLElement)?.dataset?.field ?? ''

    if (!field || column?.bindType === BIND_TYPE.ACTION) {
      return
    }

    const rowId = event.currentTarget.parentElement?.getAttribute('data-id')
    const cellColumn = columns.find(col => col.code === field)
    const cellColumnId = cellColumn?.id

    if (
      rowId &&
      cellColumnId &&
      configActions.actionsAvailable.on_cell_tooltip[cellColumnId] &&
      configActions.actionsData.on_cell_tooltip[cellColumnId]
    ) {
      onOpenTooltip(event, {
        action: configActions.actionsData.on_cell_tooltip[cellColumnId],
        column: cellColumn,
        srcObj: apiRef.current.getRow(rowId),
      })

      return
    }

    if (
      rowId &&
      configActions.actionsAvailable.on_row_tooltip &&
      configActions.actionsData.on_row_tooltip
    ) {
      onOpenTooltip(event, {
        action: configActions.actionsData.on_row_tooltip,
        srcObj: apiRef.current.getRow(rowId),
      })
    }
  }

  return {
    tooltipPosition,
    tooltipData,
    handleCloseTooltip,
    handleOpenTooltip,
  }
}
